import React from 'react';
import { motion } from 'framer-motion';

const Education = () => {
	return (
		<>
			<h3 className="w-11/12 mx-auto mb-10 text-2xl font-semibold">
				Education
			</h3>
			<motion.div
				initial={{ opacity: 0 }}
				whileInView={{
					opacity: 1,
					transition: { duration: 1.5, ease: 'easeOut' },
				}}
				viewport={{ once: true }}
				className="w-11/12 h-fit mx-auto px-5 xs:px-8 py-8 flex flex-col md:flex-row justify-center md:justify-between gap-4 rounded-xl bg-light-naive shadow-[0px_0px_7px_hsl(204,23.8%,95.9%,.7)]"
			>
				<div className="w-full md:w-3/6 mx-auto flex flex-col gap-1">
					<p className=" text-sky-blue font-bold text-lg">
						Institute Of Management And Technology (IMT), Enugu State.
					</p>
					<p className=" text-gray font-medium">
						Office Technology And Management
					</p>
					<p className="font-light">National Diploma (ND)</p>
					<p className="font-light">2017 - 2019</p>
				</div>
				<div className="w-full md:w-3/6 flex flex-col justify-start gap-4">
					<p className="underline font-medium text-lg">Relevant Coursework:</p>
					<ul className="w-full md:w-10/12 mx-auto font-light list-[square]">
						<li>Web page Design</li>
						<li>People's Communication Skill</li>
						<li>Modern Office Technology</li>
						<li>Information Communication Technology</li>
						<li>Principles of Accounting</li>
					</ul>
				</div>
			</motion.div>
		</>
	);
};

export default Education;
